import Vue from 'vue'

const client = Vue.prototype.$api

export default {
    getPatientPets () {
        return client.get('pet')
    }
}


// WEBPACK FOOTER //
// ./src/repositories/PetRepository.js